import { z } from "zod";

export const medicationsValidation = z.object({
  takingMedications: z.boolean(),
  activeMedications: z.array(z.object({
    name: z.string(),
    strength: z.string(),
    frequency: z.string(),
    startDate: z.coerce.date().max(new Date(), "Start date must be in the past"),
		endDate: z.coerce.date().max(new Date(), "Start date must be in the past").nullable().optional(),

    // Other optional medication fields
    id: z.string().optional(),
    patientId: z.string().optional(),
    providerId: z.string().optional(),
    photonPatientId: z.string().optional(),
    photonMedicationId: z.string().optional(),
    isCustomOption: z.boolean().optional(),
    brandName: z.string().nullable().optional(),
    genericName: z.string().nullable().optional(),
    description: z.string().nullable().optional(),
    status: z.enum(["ACTIVE", "INACTIVE", "PA_PENDING", "PA_DENIED"]).optional(),
    form: z.string().optional(),
  })),
  allergicToMedications: z.boolean(),
  medicationAllergies: z.array(z.object({
    name: z.string()
  })),
});
